<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="tab-content bg-white">
          <div id="novo" class="tab-pane fade show active">
            <div class="input-group px-lg-5">
              <div class="d-flex align-items-center simulado-busca w-100">
                <i class="mdi mdi-magnify ml-3 mr-3"></i>
                <auto-complete
                  v-model="termoPesquisa"
                  inputClass="flex-grow-1"
                  :placeholder="'Buscar por ' + configEmpresa.textosConfiguraveis.textoDisplaySimulado"
                  :serializer="simulado => simulado.nome"
                  @hit="selecionarSimulado($event)"
                  :data="simulados"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row m-0 simulado-filtro simulado-filtro-header">
      <div class="col-12 px-3 px-lg-5">
        <span class="texto-header-filtro">Filtrar</span>
      </div>
    </div>
    <div class="row mt-0 simulado-filtro">
      <div class="col-12 pt-0">
        <div class="bg-white py-4">
          <div class="row px-3 px-lg-5">
            <div class="col-lg-4 pb-3">
              <p class="mb-1">Categoria</p>
              <select class="form-control" id="categoria" name="categoria" v-model="categoriaSelecionada">
                <option value="">Selecione a categoria</option>
                <option v-for="categoria in categorias" :value="categoria" :key="categoria.id">{{ categoria.nome }}</option>
              </select>
            </div>
            <div class="col-lg-4 pb-3">
              <p class="mb-1">Disciplina</p>
              <select class="form-control" id="disciplina" name="disciplina" v-model="disciplinaSelecionada">
                <option value="">Selecione a disciplina</option>
                <option v-for="disciplina in disciplinas" :value="disciplina" :key="disciplina.id">{{ disciplina.nome }}</option>
              </select>
            </div>
            <div class="col-lg-4 pb-3">
              <p class="mb-1">Curso</p>
              <select class="form-control" id="curso" name="curso" v-model="cursoSelecionado">
                <option value="">Selecione o curso</option>
                <option v-for="curso in cursos" :value="curso" :key="curso.id">{{ curso.nome }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row d-none d-lg-block">
          <div class="col-12">
            <div class="bg-white">
              <div class="row px-5">
                <div class="col-12 pb-3">
                  <span class="badge badge-pill badge-info text-lowercase mr-2" v-if="categoriaSelecionada.nome">
                    <span>{{ categoriaSelecionada.nome }}</span>
                    <button type="button" class="close" @click="categoriaSelecionada = ''; sortNovos()">
                      <i class="mdi mdi-close-circle"></i>
                    </button>
                  </span>
                  <span class="badge badge-pill badge-info text-lowercase mr-2" v-if="disciplinaSelecionada.nome">
                    <span>{{ disciplinaSelecionada.nome }}</span>
                    <button type="button" class="close" @click="disciplinaSelecionada = ''">
                      <i class="mdi mdi-close-circle"></i>
                    </button>
                  </span>
                  <span class="badge badge-pill badge-info text-lowercase" v-if="cursoSelecionado.nome">
                    <span>{{ cursoSelecionado.nome }}</span>
                    <button type="button" class="close" @click="cursoSelecionado = ''">
                      <i class="mdi mdi-close-circle"></i>
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr class="mt-0" />
      </div>
    </div>
    <div class="row px-lg-5 pb-3" v-if="categoriaSelecionada !== ''">
      <div class="col-lg-6 d-flex align-items-center text-left mb-lg-0 mt-lg-0 mt-4">
        <div class="d-flex flex-column justify-content-md-start w-100">
          <p class="header-simulado-categoria">{{ categoriaSelecionada.nome }}</p>
          <p class="header-simulado-disciplina">{{ disciplinaSelecionada.nome }}</p>
          <hr class="d-block d-lg-none" />
        </div>
      </div>
      <div class="col-lg-6 d-flex flex-column align-items-end simulado-ordenar">
        <div class="align-self-lg-end align-self-stretch">
          <span class="d-block mb-1">Ordenar por</span>
          <select id="filtroSimulados" name="filtroSimulados" class="form-control" v-model="filtroSimulados">
            <option value="recentes">Mais novos</option>
            <option value="realizados">Mais acessados</option>
          </select>
        </div>
      </div>
    </div>
    <div class="row px-lg-5">
      <div class="meus-sim col-12 sim-empresa">
        <div class="row px-5 sem-resultados my-5" v-if="categoriaSelecionada === ''">
          <div class="col-12 my-5">
            <p>Filtre pelo seu interesse e comece a estudar.</p>
            <p>
              <small>Não se preocupe em finalizar um <span class="text-lowercase">{{configEmpresa.textosConfiguraveis.textoDisplaySimulado}}</span>, continue quando<br>quiser e acompanhe seu progresso.</small>
            </p>
          </div>
        </div>
        <span>
          <div class="div-card-simulado" v-for="simulado in simuladosPaginados" v-bind:key="simulado.id">
            <div class="item-simulado-em-progresso d-flex flex-lg-row flex-column mb-3 w-100" @click="selecionarSimulado(simulado)">
              <div class="col-lg-6 d-flex align-items-center">
                <div class="nome-simulado1">
                  <p class="muted" v-if="cursoSelecionado === ''">{{ simulado.curso.nome }}</p>
                  {{ simulado.nome }}
                </div>
              </div>
              <div class="col-lg-6 d-flex flex-lg-column flex-row-reverse justify-content-end justify-content-lg-center position-static px-0 py-0 py-lg-2">
                <div class="d-flex align-items-center justify-content-lg-end pr-5 div-questoes-simulado">
                  <span class="questoes-simulado">{{ simulado.qtdQuestoes }} questões</span>
                </div>
              </div>
              <div class="play"></div>
            </div>
          </div>
        </span>
        <div class="col-12" v-if="categoriaSelecionada !== ''">
            <div class="align-items-center d-flex flex-column flex-lg-row justify-content-end">
              <ul class="align-items-center d-flex pagination mb-2">
                <li class="page-item mr-2"><b>Mostrar</b></li>
                <li class="page-item" :class="{ active: pagination.itemsPerPage === 10 }">
                  <a class="page-link" @click="setItems(10)">10</a>
                </li>
                <li class="page-item" :class="{ active: pagination.itemsPerPage === 30 }">
                  <a class="page-link" @click="setItems(30)">30</a>
                </li>
                <li class="page-item" :class="{ active: pagination.itemsPerPage === 50 }">
                  <a class="page-link" @click="setItems(50)">50</a>
                </li>
              </ul>
              <nav class="ml-lg-5">
                <ul class="align-items-center d-flex pagination mb-2">
                  <li class="page-item mr-2"><b>Página</b></li>
                  <li class="page-item" v-for="(value, index) in pages" :key="value" :class="{ active: pagination.page == value }">
                    <a class="page-link" v-if="Math.abs(index - pagination.page) < 3 || index == pages - 1 || index == 0" @click="goToPage(value)">{{ value }}</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
      </div>
      <!-- -->
    </div>
  </div>
</template>

<script>
import CategoriaAPI from '@/api/categorias-api'
import SimuladoAPI from '@/api/simulado-api'
import ResponseUtils from '@/core/utils/response-utils'
import AutoComplete from '@/core/components/autocomplete/AutoComplete'
import DateUtils from '@/core/utils/date-utils'

export default {
  name: 'SimuladosInstituicao',
  components: { AutoComplete },
  data () {
    return {
      categorias: [],
      powerUps: [],
      categoriaSelecionada: {
        disciplinas: ''
      },
      disciplinaSelecionada: '',
      cursoSelecionado: '',
      disciplinas: '',
      termoPesquisa: '',
      simulados: [],
      filtroSimulados: 'recentes',
      pagination: {
        page: 1,
        total: 0,
        itemsPerPage: 10
      }
    }
  },

  async mounted () {
    const loader = this.$loading.show()

    const categorias = await CategoriaAPI.listarCategorias().then(data => data.categorias)

    const categoriasDisciplinasSimulados = await SimuladoAPI.listarSimuladosEmDisciplinas()

    categorias.forEach((categoria, c) => {
      const categoriaDisciplinas = categoriasDisciplinasSimulados.find(item => item.id === categoria.id)
      if (categoriaDisciplinas) categoria.disciplinas = categoriaDisciplinas.disciplinas

      if (typeof categoria.disciplinas !== 'undefined') {
        for (let i = categoria.disciplinas.length - 1; i >= 0; i--) {
          let disciplina = categoria.disciplinas[i]
          for (let x = disciplina.cursos.length - 1; x >= 0; x--) {
            let curso = disciplina.cursos[x]
            for (let y = curso.simulados.length - 1; y >= 0; y--) {
              let simulado = curso.simulados[y]
              const simul = this.simulados.find(item => item.id === simulado.id)
              if (!simul) {
                this.simulados.push(simulado)
              } else {
                categoria.disciplinas[i].cursos[x].simulados.splice(y, 1)
              }
            }
            if (categoria.disciplinas[i].cursos[x].simulados.length === 0) {
              categoria.disciplinas[i].cursos.splice(x, 1)
            }
          }
          if (categoria.disciplinas[i].cursos.length === 0) {
            categoria.disciplinas.splice(i, 1)
          }
        }
        if (categoria.disciplinas.length === 0) {
          categorias.splice(c, 1)
        }
      }
    })

    this.categorias = categorias.map((item, index) => {
      return Object.assign(item, { nome: item.title, visivel: index === 0 })
    }).filter(item => item.disciplinas)

    for (let x = this.categorias.length - 1; x >= 0; x--) {
      let categoria = this.categorias[x]
      if (typeof categoria.disciplinas !== 'undefined') {
        if (categoria.disciplinas.length === 0) {
          this.categorias.splice(x, 1)
        }
      }
    }
    if (this.categorias.length > 0) {
      this.categoriaSelecionada = this.categorias[0]
      this.disciplinas = this.categoriaSelecionada.disciplinas
    }

    this.pagination.total = this.simulados.length

    loader.hide()
  },

  watch: {
    categoriaSelecionada () {
      this.disciplinas = this.categoriaSelecionada.disciplinas
      this.disciplinaSelecionada = ''
    }
  },

  computed: {
    cursos: function () {
      let cursos = []
      if (!this.disciplinaSelecionada) {
        const disciplinas = this.categoriaSelecionada.disciplinas
        if (!disciplinas) return
        disciplinas.forEach((disciplina) => {
          cursos.push(...disciplina.cursos)
        })
        return cursos
      }
      return this.disciplinaSelecionada.cursos
    },
    simuladosPaginados: function () {
      let simulados = []
      if (!this.disciplinaSelecionada) {
        const disciplinas = this.disciplinas
        if (!disciplinas) return
        disciplinas.forEach((disciplina) => {
          const disciplinaCursos = disciplina.cursos
          disciplinaCursos.forEach((curso) => {
            let cursoSimulados = curso.simulados
            cursoSimulados = cursoSimulados.map(item => ({ ...item, curso }))

            simulados.push(...cursoSimulados)
          })
        })
      } else if (!this.cursoSelecionado) {
        const cursos = this.cursos
        cursos.forEach((curso) => {
          let cursoSimulados = curso.simulados
          cursoSimulados = cursoSimulados.map(item => ({ ...item, curso }))

          simulados.push(...cursoSimulados)
        })
      } else {
        simulados = this.cursoSelecionado.simulados
      }
      return this.obtemSimuladosTela(simulados)
    },
    configEmpresa: function () {
      return this.$store.getters.empresa
    },
    indexStart () {
      return (this.pagination.page - 1) * this.pagination.itemsPerPage
    },
    indexEnd () {
      return this.indexStart + this.pagination.itemsPerPage
    },
    pages () {
      return !this.simulados.length ? 1 : Math.ceil(this.simulados.length / this.pagination.itemsPerPage)
    }
  },

  methods: {
    sortNovos: function (simulados) {
      return simulados.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    },
    sortExecucoes: function (simulados) {
      return simulados.sort((a, b) => b.total_execucoes - a.total_execucoes)
    },
    exibir: function (item) {
      this.categorias.forEach(cat => {
        cat.visivel = cat === item
      })
      this.powerUps.forEach(pwUp => {
        pwUp.visivel = pwUp === item
      })
    },
    selecionarSimulado: function (simulado) {
      const idSimulado = simulado.id

      const loader = this.$loading.show()

      SimuladoAPI.criarSimuladoUsandoModelo(idSimulado).then(data => {
        if (data && data.simulado) {
          window.location = `/simulados/prova/${data.simulado}`
        } else {
          loader.hide()
        }
      }).catch(error => ResponseUtils.handleError(error, loader))
    },
    dataCadastro: function (date) {
      if (date !== null) {
        return DateUtils.formatDate(date, 'DD/MM/YYYY')
      }
      return 'Data não informada'
    },
    setItems: function (items) {
      this.pagination.itemsPerPage = items
    },
    goToPage: function (page) {
      this.pagination.page = page
    },
    obtemSimuladosTela (simulados) {
      if (this.filtroSimulados === 'realizados') {
        simulados = this.sortExecucoes(simulados)
      } else {
        simulados = this.sortNovos(simulados)
      }
      this.simulados = simulados
      this.pagination.total = simulados.length
      return simulados.slice(this.indexStart, this.indexEnd)
    }
  }
}
</script>
